import script from "./TgCloudinaryUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./TgCloudinaryUploader.vue?vue&type=script&setup=true&lang=js"

import "./TgCloudinaryUploader.vue?vue&type=style&index=0&id=4f43da2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f43da2e"]])

export default __exports__